<template>
  <div class="sk-player" :class="{ 'sk-player--focused': focused }">

    <div class="sk-player__player">
      <div class="tabs">

        <div class="sk-player__close" @click="focused = !focused">&times;</div>

        <div class="tabs__options">
          <div class="tabs__option" @click="switchTab('podcasts')"
            :class="{ 'tabs__option--active': activeTab == 'podcasts' }">Podcast</div>
          <div class="tabs__option" @click="switchTab('stream')"
            :class="{ 'tabs__option--active': activeTab == 'stream' }">Live</div>
        </div>

        <div class="tabs__tab" v-show="activeTab == 'podcasts'">
          <podcast-coverart />
          <player-info />
          <player />
          <player-buttons :stream-url="streamUrl" />
        </div>

        <div class="tabs__tab" v-show="activeTab == 'stream'">
          <stream-coverart />
          <stream-info />
          <stream-buttons :stream-url="streamUrl" />
        </div>

        <show-list :shows-api="showsApi" :country="country" />
      </div>
    </div>

    <div class="sk-player__mobile">
      <div class="sk-player__mobile-container" v-show="activeTab == 'podcasts'">
        <podcast-coverart />
        <player-info />
      </div>

      <div class="sk-player__mobile-container" v-show="activeTab == 'stream'">
        <stream-coverart />
        <stream-info />
      </div>
      <div class="sk-player__mobile-toggle buttons__button buttons__audiotheek" @click="focused = !focused">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M255 48c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 160c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 160c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"/></svg>
      </div>
    </div>

  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'SkPlayer',
  components: {
    'Player': () => import('./Player'),
    'ShowList': () => import('./ShowList'),
    'PlayerButtons': () => import('./PlayerButtons'),
    'StreamButtons': () => import('./StreamButtons'),
    'PlayerInfo': () => import('./PlayerInfo'),
    'StreamInfo': () => import('./StreamInfo'),
    'PodcastCoverart': () => import('./PodcastCoverart'),
    'StreamCoverart': () => import('./StreamCoverart'),
  },
  props: [
    'showsApi',
    'streamApi',
    'streamUrl',
    'country'
  ],
  data: function () {
    return {
      focused: false,
      polls: {
        info: {
          id: null,
          interval: 2000, //1 times per second
          hook: () => {
            this.getApi();
          }
        }
      },
    }
  },
  computed: {
    activeTab() { return this.$store.state.player.activeTab; },
  },
  methods: {
    switchTab(tab) {
      this.$store.commit('player/setActiveTab', tab);
    },
    init() {
      this.$data.polls.info.id = setInterval(this.$data.polls.info.hook, this.$data.polls.info.interval)
    },
    getApi() {
      Axios.get(this.streamApi + 'live-info-v2')
        .then((resonse) => {
          var current = resonse.data.tracks.current;
          var streamInfo = {
            img: current.album_artwork_image,
            episode: current.metadata.track_title,
            name: current.metadata.album_title,
            presenter: current.metadata.artist_name
          }
          this.$store.commit('player/setStreamInfo', streamInfo);
        })
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="scss">
.sk-player {
  position: relative;

  * {
    box-sizing: border-box;
  }

  &__close {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    font-size: 1.5rem;

    @include media-breakpoint-up(xl) {
      display: none;
    }
  }

  &__player {
    @include media-breakpoint-down(xl) {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      overflow: scroll;
      transform: translateY(100%);
      transition: 0.1s ease;
      background: #fff;
      padding: 1rem;

      @at-root .sk-player--focused & {
        transform: translateY(0);
      }
    }
  }

  &__mobile {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 1rem 3.75rem 1rem 1.25rem;
    transform: translateY(0);
    transition: 0.1s ease;
    box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.3);

    @at-root .sk-player--focused & {
      transform: translateY(100%);
    }

    @include media-breakpoint-up(xl) {
      display: none;
    }

    &-container {
      display: flex;
      align-items: center;
    }

    &-toggle {
      position: absolute;
      right: 1.25rem;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      font-size: 1.5rem;

      svg {
        width: 1.5rem;
      }
    }

    .coverart {
      width: 4rem;
      height: 4rem;
    }

    .player-info {
      width: calc(100% - 4rem);
      margin: 0;
      padding: 0 1.25rem;

      &__episode {
        font-size: 1rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &__show {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .tabs {
    position: relative;

    &__options {
      display: flex;
      margin-bottom: 1.25rem;
      border-bottom: 2px solid $c-primary-20;
    }

    &__option {
      font-size: 1.5rem;
      font-weight: bold;
      padding: 0 0 1.5rem 0;
      border-bottom: 2px solid transparent;
      margin-bottom: -2px;
      margin-right: 2rem;
      cursor: pointer;

      &--active {
        border-color: $c-primary-100;
      }

      @include media-breakpoint-down(xl) {
        padding: 0 0 .5rem 0;
      }
    }

  }
}
</style>
